const removeNodeIfContained = (nodeToRemove, nodeParent) => {
  if (nodeParent && nodeToRemove && nodeParent.contains(nodeToRemove)) {
    nodeParent.removeChild(nodeToRemove);
  }
};

export default removeNodeIfContained;
